import type * as Radix from "@radix-ui/react-primitive";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import React from "react";

export const TooltipProvider = TooltipPrimitive.Provider;

export const TooltipClassName =
  "bg-neutral-700 font-medium text-neutral-50 rounded px-3 py-1.5 max-w-64 text-center whitespace-pre";

export function Tooltip({
  children,
  content,
  open,
  defaultOpen,
  onOpenChange,
  delayDuration,
  disabled = false,
  ...props
}: Radix.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> & {
  children: React.ReactNode;
  content: React.ReactNode;
  open?: boolean;
  defaultOpen?: boolean;
  delayDuration?: number;
  onOpenChange?: (open: boolean) => void;
  disabled?: boolean;
}) {
  return (
    <TooltipPrimitive.Root
      open={open}
      defaultOpen={defaultOpen}
      onOpenChange={onOpenChange}
      delayDuration={delayDuration}
    >
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      {!disabled ? (
        <TooltipPrimitive.Content
          side="top"
          sideOffset={4}
          align="center"
          className={TooltipClassName}
          {...props}
        >
          {content}
        </TooltipPrimitive.Content>
      ) : null}
    </TooltipPrimitive.Root>
  );
}
